import { Link } from 'react-router-dom';

import { residentSlug } from '@/data/events';
import { useI18n } from '@/providers/i18n';
import type { Lineup } from '@/types';

import styles from './LineupStages.module.css';

interface LineupStagesProps {
  lineup: Lineup;
}

export default function LineupStages({ lineup }: LineupStagesProps) {
  const { t } = useI18n();
  const stages = Object.keys(lineup).length;
  const artistTotal = Object.values(lineup).reduce((a, b) => a + b.length, 0);

  return (
    <section id="lineup" className={styles.root}>
      <header className={styles.sectionH}>
        <span className={styles.headNum}>/ 03</span>
        <span className={styles.headTtl}>{t('label.lineup')}</span>
        <span className={styles.headMeta}>
          {stages} STAGES · {artistTotal} ARTISTS
        </span>
      </header>
      {Object.entries(lineup).map(([stage, artists], i) => (
        <div
          key={stage}
          className={`${styles.stage} ${i === 0 ? styles.first : ''}`}
        >
          <div className={styles.stageH}>
            <span>
              STAGE {String(i + 1).padStart(2, '0')} · {stage}
            </span>
            <span>{artists.length} ARTISTS</span>
          </div>
          <div className={styles.artists}>
            {artists.map((a) => {
              const sl = residentSlug(a);
              return sl ? (
                <Link key={a} to={`/artists/${sl}`} className={styles.artist}>
                  <span>{a}</span>
                </Link>
              ) : (
                <span key={a} className={styles.artist}>
                  {a}
                </span>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}
